import { NAME_CREATORS } from '../../Creators/constants/nameCreators';

export const initialItemData = {
  orgId: '',
  streamId: '',
  channelId: '',
  id: '',
  type: '',
  published: true,
  itemTags: [],
  moderationTags: [],
  itemMentions: [],
  refId: null,
  summary: '',
  content: {
    title: '',
    snippet: '',
    attachments: [],
    tags: [],
    keyNoteTag: '',
    noteTags: [],
    mentions: [],
    properties: {},
    processed: '',
    metadata: {
      createdBy: '',
      createdAt: '',
      editedBy: '',
      editedAt: '',
      hash: '',
    },
  },
  metadata: {
    streamItemId: '',
    createdAt: '',
    createdBy: '',
    editedBy: '',
    editedAt: '',
    publishedBy: '',
    publishedAt: '',
    hash: '',
    license: '',
    commentCount: 0,
    shareCount: 0,
    score: 0,
    endorsedCount: 0,
    rebuzzable: true,
    commentable: true,
    parentItemId: null,
    public: true,
    pinnedUntil: null,
    locked: false,
    unlockPrice: null,
    publishTimeline: true,
    rebuzzCount: 0,
    archived: false,
    pinInterval: null,
    archiveInterval: null,
    publishingSchedule: null,
    freezeThreadOn: false,
    notificationOff: true,
    tipCoins: 0,
    tipCurrency: 0,
    reactionCounts: {},
    endorsedBy: [],
    aggregateChannels: [],
    blockedThread: false,
  },
  bountyPurse: [],
  userData: {
    hasCommented: false,
    hasBookmarked: false,
    reactions: [],
    tags: [],
  },
  threadInfo: {
    // NOTE: this is assumed key and may change based on backend data
    itemsInThread: 0,
    publicItems: 0,
    subscriptionItems: 0,
    enabledForRebuzz: 0,
    publicItemsEnabled: 0,
    subscriptionItemsEnabled: 0,
    rebuzzablePublicItems: 0,
  },
};

export const initialRssFeed = {
  id: '',
  orgId: '',
  streamId: '',
  channelId: '',
  name: '',
  url: '',
  description: '',
  tags: [],
  priority: null,
  createPrivateItem: false,
  ignoreFeedTags: false,
  metadata: {
    createdAt: '',
    createdBy: '',
    lastUpdated: '',
    locked: false,
    scrapedAt: '',
  },
};

export const initialRebuzzIn = {
  list: [],
  count: null,
  total: null,
};

export const SYSTEM_CREATOR_ITEMS = [
  {
    title: 'organization',
    type: NAME_CREATORS.ORGANIZATION,
    btnTitle: 'createOrganization',
    snippet:
      '<div class="paragraph">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis interdum habitasse vulputate leo. Sapien facilisis mattis odio imperdiet bibendum vitae eget dignissim luctus. Cursus consectetur aliquam, massa quisque morbi id fusce. Adipiscing id ...\n</div>',
  },
  {
    title: 'stream',
    type: NAME_CREATORS.STREAM,
    btnTitle: 'createStream',
    snippet:
      '<div class="paragraph">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis interdum habitasse vulputate leo. Sapien facilisis mattis odio imperdiet bibendum vitae eget dignissim luctus. Cursus consectetur aliquam, massa quisque morbi id fusce. Adipiscing id ...\n</div>',
  },
  {
    title: 'channel',
    type: NAME_CREATORS.CHANNEL,
    btnTitle: 'createChannel',
    snippet:
      '<div class="paragraph">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis interdum habitasse vulputate leo. Sapien facilisis mattis odio imperdiet bibendum vitae eget dignissim luctus. Cursus consectetur aliquam, massa quisque morbi id fusce. Adipiscing id ...\n</div>',
  },
];

export const SUBSCRIPTIONS_CREATOR_ITEMS = [
  {
    title: 'subscriptionsPackage',
    type: NAME_CREATORS.SUBSCRIPTION,
    btnTitle: 'createSubscription',
    snippet:
      '<div class="paragraph">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis interdum habitasse vulputate leo. Sapien facilisis mattis odio imperdiet bibendum vitae eget dignissim luctus. Cursus consectetur aliquam, massa quisque morbi id fusce. Adipiscing id ...\n</div>',
  },
  {
    title: 'supportPackage',
    type: NAME_CREATORS.SUPPORT,
    btnTitle: 'createSupport',
    snippet:
      '<div class="paragraph">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis interdum habitasse vulputate leo. Sapien facilisis mattis odio imperdiet bibendum vitae eget dignissim luctus. Cursus consectetur aliquam, massa quisque morbi id fusce. Adipiscing id ...\n</div>',
  },
  {
    title: 'rolesPackage',
    type: NAME_CREATORS.ROLES_PACKAGE,
    btnTitle: 'createRolesPackage',
    snippet:
      '<div class="paragraph">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis interdum habitasse vulputate leo. Sapien facilisis mattis odio imperdiet bibendum vitae eget dignissim luctus. Cursus consectetur aliquam, massa quisque morbi id fusce. Adipiscing id ...\n</div>',
  },
  {
    title: 'RSSFeed',
    type: NAME_CREATORS.RSS_FEED,
    btnTitle: 'addRSSFeed',
    snippet:
      '<div class="paragraph">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis interdum habitasse vulputate leo. Sapien facilisis mattis odio imperdiet bibendum vitae eget dignissim luctus. Cursus consectetur aliquam, massa quisque morbi id fusce. Adipiscing id ...\n</div>',
  },
];
